import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '@/hooks/redux-helpers';

import { store } from '@/store/configuration';
import { IDashboardConfig } from '@/store/models/dashboard-config.model';

import { getDashboardConfig } from '@/store/actions/dashboard-config.actions';

import splitURL from '@/utils/splitURL';

export function parseConfig(config: IDashboardConfig | undefined): IDashboardConfig | undefined {
  if (!config) {
    return undefined;
  }
  const { hasSubfolder, version } = splitURL();
  if (config?.site) {
    if (hasSubfolder) {
      config.site.path = '/' + version;
    } else {
      config.site.path = '';
    }
  }

  if (hasSubfolder && config.api.sso.redirectUri.indexOf(version) == -1) {
    const ssoURI = splitURL(config.api.sso.redirectUri);
    config.api.sso.redirectUri = `${ssoURI.rootURL}${version}/${ssoURI.path}`;
  }

  if (hasSubfolder && config.api.oauth.redirectUri.indexOf(version) == -1) {
    const oauthURI = splitURL(config.api.oauth.redirectUri);
    config.api.oauth.redirectUri = `${oauthURI.rootURL}${version}/${oauthURI.path}`;
  }

  return config;
}

export const useDashboardConfig = (): IDashboardConfig | undefined => {
  const dispatch = useAppDispatch();

  const config = useAppSelector((state) => state.dashboardConfig.config);

  useEffect(() => {
    if (!config) {
      dispatch(getDashboardConfig());
    }
  }, [config, dispatch]);

  return parseConfig(config);
};

export const getStaticDashboardConfig = (): IDashboardConfig => {
  const config = store.getState().dashboardConfig.config;

  if (!config) {
    console.error('Dashboard Config not found');
  }

  return parseConfig(config);
};
